import styled from "styled-components";

export const FestivalCompetitionsWrapper = styled.div`
  width: 100%;
  padding-bottom: 100px;
`;

export const FestivalCompetitionsHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 16px 12px;

  > .title {
    font-weight: 700;
    font-size: 20px;
    color: #121212;
  }
`;
